
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as blogR63mXqFGNZejSTEG7BDd1MNSdD7y99Exqt5WzqnOHFAMeta } from "/vercel/path0/pages/blog.vue?macro=true";
import { default as aboutOS7HpsGFDFSTbbd4iXDP92Iuvckam0GQw5dgZEXCgBIMeta } from "/vercel/path0/pages/about.vue?macro=true";
import { default as indexG_WfXOzFIdmY7nC2wskK9_5LGE8hGwIJyZEyCaXLOuMMeta } from "/vercel/path0/pages/index.vue?macro=true";
import { default as loginyiubrZraL9EDD3J38Z_45ftLpCUym9OoYm1Hb9453rWnMMeta } from "/vercel/path0/pages/login.vue?macro=true";
import { default as coursestzH79a43wzDeOKKpg1LMmAH9kHRE9_45mBSb3XBf9vwK4Meta } from "/vercel/path0/pages/courses.vue?macro=true";
import { default as profileFId_45d62DZvDfSRqu_45gOkgT1Y2dyc04X7CB8OOqCLklMMeta } from "/vercel/path0/pages/profile.vue?macro=true";
import { default as for_45llmswKKLvXs0zxrjhsfIKR9PigNdymYVMn0ezfh7DfWNCqcMeta } from "/vercel/path0/pages/for-llms.vue?macro=true";
import { default as _91_46_46_46slug_93eD0_45aLJH_SWaJVw5CBvPn8cEE2xWIMXlvr23TEyf8PMMeta } from "/vercel/path0/pages/[...slug].vue?macro=true";
import { default as workshops4r4K73aYS2IiU1lRLIkIjZuPfFoplNcnsHYAzFg6BD0Meta } from "/vercel/path0/pages/workshops.vue?macro=true";
import { default as magic_45linkxXdnGmHRmG_7CmQfEj8XCBBr7p9tdNt1XJYjtiWqMxMMeta } from "/vercel/path0/pages/magic-link.vue?macro=true";
import { default as newsletterH_45g7hJhIesr1Yd4w894jLuCjMEF_G1fTFhcGgvDk6usMeta } from "/vercel/path0/pages/newsletter.vue?macro=true";
import { default as subscribedJN4L1boi1Q2hIGnd3rKFSp6pu37v3R48KTIKX_Oe8bUMeta } from "/vercel/path0/pages/subscribed.vue?macro=true";
import { default as callbackh5BlNk_5NmpfVDD4b6dX2d7K12NPXA5wsmB_CKYJNNsMeta } from "/vercel/path0/pages/auth/callback.vue?macro=true";
import { default as privacy_45policy4XTtqETNZShW4bt4tv1KYsHRfQDwaNm0MGXT0dxQJr0Meta } from "/vercel/path0/pages/privacy-policy.vue?macro=true";
import { default as speaking_45policySDMQYeqyzlxh_451dTy_4518K8bCzNDXhBOuvknYzK4Xx4oMeta } from "/vercel/path0/pages/speaking-policy.vue?macro=true";
import { default as terms_45of_45serviceQuvQu15QrOEvfk8Simejfn_Ba6eU187th49_hXEj6RQMeta } from "/vercel/path0/pages/terms-of-service.vue?macro=true";
import { default as content_45authoringLRKj5VTnR6ZWjbaYXNQTsryyhpbrO2ud8Gw7rt_45fo_oMeta } from "/vercel/path0/pages/content-authoring.vue?macro=true";
import { default as private_45workshopsh_45pLngdie5_Mf9O_45eZFdC8LfcMlR_Dw_r1htPQQEZVQMeta } from "/vercel/path0/pages/private-workshops.vue?macro=true";
import { default as company_45consultingeGfYtdRMUPFJRlG2YX86cONcQhs0oZ_e5tsoEIOFktsMeta } from "/vercel/path0/pages/company-consulting.vue?macro=true";
import { default as individual_45tutoringAWjOPBj_tIHsKy87RnFRCZxgOjjQV3kOpDSo1RnCiJgMeta } from "/vercel/path0/pages/individual-tutoring.vue?macro=true";
import { default as setting_45up_45trello_45appKw5g_45bm4vA38znaKHEqBGtPCH33fDFWrBr_45_45Ii3Thk8Meta } from "/vercel/path0/pages/setting-up-trello-app.vue?macro=true";
import { default as registrationqbG3AJBTf6NR3SV50D_Irll4ELVYrx_45DyTv5Hhg7t2IMeta } from "/vercel/path0/pages/workshop/registration.vue?macro=true";
import { default as _99_45cypress_45tips5d7vpjK6Lewtxs1S8n7Apw7sJM92a4jmNf4HfZ0HJlwMeta } from "/vercel/path0/pages/course/99-cypress-tips.vue?macro=true";
import { default as index4NuSDB6gV3l7Vs4EDERBnIdutPs_ZpU5tI2cFQdOCwMMeta } from "/vercel/path0/pages/course/[slug]/lesson/index.vue?macro=true";
import { default as cypress_45api_91_91id_93_93Da5clyxGLvACiJfLH2TJWM8W6cHT3LhLFv_TzWINztkMeta } from "/vercel/path0/pages/workshop/cypress-api[[id]].vue?macro=true";
import { default as group_45pricingjPaGbe1_ab_45hH1ZSuU46mgY3qEX5MZVg2Vmt88Hp6tYMeta } from "/vercel/path0/pages/course/[slug]/group-pricing.vue?macro=true";
import { default as payment_45confirmationEqRZmNFKlDLMUk0NM_KGndoqjEbgogrmSo_c_45ZFNREoMeta } from "/vercel/path0/pages/course/payment-confirmation.vue?macro=true";
import { default as cypress_45core_91_91id_93_9355A4ozXCQFVQ_45YabZDoCD9byFpQRv18HysSEH_45ZzcVwMeta } from "/vercel/path0/pages/workshop/cypress-core[[id]].vue?macro=true";
import { default as cypress_45typescript_91_91id_93_938MZvrqPawWp5vLtmudNhzhhUODdjalK4TxvvQZp8VKwMeta } from "/vercel/path0/pages/workshop/cypress-typescript[[id]].vue?macro=true";
export default [
  {
    name: "blog",
    path: "/blog",
    component: () => import("/vercel/path0/pages/blog.vue")
  },
  {
    name: "about",
    path: "/about",
    component: () => import("/vercel/path0/pages/about.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/vercel/path0/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    component: () => import("/vercel/path0/pages/login.vue")
  },
  {
    name: "courses",
    path: "/courses",
    component: () => import("/vercel/path0/pages/courses.vue")
  },
  {
    name: "profile",
    path: "/profile",
    component: () => import("/vercel/path0/pages/profile.vue")
  },
  {
    name: "for-llms",
    path: "/for-llms",
    component: () => import("/vercel/path0/pages/for-llms.vue")
  },
  {
    name: "slug",
    path: "/:slug(.*)*",
    component: () => import("/vercel/path0/pages/[...slug].vue")
  },
  {
    name: "workshops",
    path: "/workshops",
    component: () => import("/vercel/path0/pages/workshops.vue")
  },
  {
    name: "magic-link",
    path: "/magic-link",
    component: () => import("/vercel/path0/pages/magic-link.vue")
  },
  {
    name: "newsletter",
    path: "/newsletter",
    component: () => import("/vercel/path0/pages/newsletter.vue")
  },
  {
    name: "subscribed",
    path: "/subscribed",
    component: () => import("/vercel/path0/pages/subscribed.vue")
  },
  {
    name: "auth-callback",
    path: "/auth/callback",
    component: () => import("/vercel/path0/pages/auth/callback.vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    component: () => import("/vercel/path0/pages/privacy-policy.vue")
  },
  {
    name: "speaking-policy",
    path: "/speaking-policy",
    component: () => import("/vercel/path0/pages/speaking-policy.vue")
  },
  {
    name: "terms-of-service",
    path: "/terms-of-service",
    component: () => import("/vercel/path0/pages/terms-of-service.vue")
  },
  {
    name: "content-authoring",
    path: "/content-authoring",
    component: () => import("/vercel/path0/pages/content-authoring.vue")
  },
  {
    name: "private-workshops",
    path: "/private-workshops",
    component: () => import("/vercel/path0/pages/private-workshops.vue")
  },
  {
    name: "company-consulting",
    path: "/company-consulting",
    component: () => import("/vercel/path0/pages/company-consulting.vue")
  },
  {
    name: "individual-tutoring",
    path: "/individual-tutoring",
    component: () => import("/vercel/path0/pages/individual-tutoring.vue")
  },
  {
    name: "setting-up-trello-app",
    path: "/setting-up-trello-app",
    component: () => import("/vercel/path0/pages/setting-up-trello-app.vue")
  },
  {
    name: "workshop-registration",
    path: "/workshop/registration",
    component: () => import("/vercel/path0/pages/workshop/registration.vue")
  },
  {
    name: "course-99-cypress-tips",
    path: "/course/99-cypress-tips",
    component: () => import("/vercel/path0/pages/course/99-cypress-tips.vue")
  },
  {
    name: "course-slug-lesson",
    path: "/course/:slug()/lesson",
    component: () => import("/vercel/path0/pages/course/[slug]/lesson/index.vue")
  },
  {
    name: "workshop-cypress-apiid",
    path: "/workshop/cypress-api:id?",
    component: () => import("/vercel/path0/pages/workshop/cypress-api[[id]].vue")
  },
  {
    name: "course-slug-group-pricing",
    path: "/course/:slug()/group-pricing",
    component: () => import("/vercel/path0/pages/course/[slug]/group-pricing.vue")
  },
  {
    name: "course-payment-confirmation",
    path: "/course/payment-confirmation",
    component: () => import("/vercel/path0/pages/course/payment-confirmation.vue")
  },
  {
    name: "workshop-cypress-coreid",
    path: "/workshop/cypress-core:id?",
    component: () => import("/vercel/path0/pages/workshop/cypress-core[[id]].vue")
  },
  {
    name: "workshop-cypress-typescriptid",
    path: "/workshop/cypress-typescript:id?",
    component: () => import("/vercel/path0/pages/workshop/cypress-typescript[[id]].vue")
  }
]